(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AvmPrequalificationsController', AvmPrequalificationsController);

    AvmPrequalificationsController.$inject = ['$state', '$uibModal', 'AvmPrequalifications', 'ParseLinks', 'AlertService', 'FileSaver', 'moment', 'pagingParams'];

    function AvmPrequalificationsController ($state, $uibModal, AvmPrequalifications, ParseLinks, AlertService, FileSaver, moment, pagingParams) {
        var vm = this;
        var defaultSort = 'createdDate,desc';

        vm.pagingParams = pagingParams;
        vm.probes = null;
        vm.links = null;
        vm.totalItems = null;
        vm.fromDate = moment().subtract(1, 'month').toDate();
        vm.toDate = moment().toDate();
        vm.outcome = null;      // null = all outcomes
        vm.coverage = null;     // null = all coverage
        vm.profile = null;      // null = all profiles
        vm.province = null;     // two-letter code, exact match
        vm.fsa = null;          // leading three of the postal code
        vm.addressQuery = null; // free-text search over the probed address

        vm.outcomes = [
            { value: null, label: 'All Outcomes' },
            { value: 'PASSED', label: 'Passed' },
            { value: 'REJECTED_LOW_CONFIDENCE', label: 'Rejected - Low Confidence' },
            { value: 'MISCONFIGURED', label: 'Misconfigured' },
            { value: 'CALL_FAILED', label: 'Call Failed' }
        ];
        // Only the three Gnowise coverage values can appear in this table; AppraisalType has many more.
        vm.coverages = [
            { value: null, label: 'All Coverage' },
            { value: 'AVM_VALUATION', label: 'Valuation' },
            { value: 'AVM_MARKET_RENT', label: 'Market Rent' },
            { value: 'AVM_VALUATION_AND_MARKET_RENT', label: 'Valuation and Market Rent' }
        ];
        vm.profiles = [
            { value: null, label: 'All Profiles' },
            { value: 'ENRICHED', label: 'Enriched' },
            { value: 'ESSENTIALS', label: 'Essentials' },
            { value: 'ADJUSTED', label: 'Adjusted' }
        ];

        vm.loadData = loadData;
        vm.transition = transition;
        vm.applyFilters = applyFilters;
        vm.exportCsv = exportCsv;
        vm.viewRequest = viewRequest;
        vm.viewClientRequest = viewClientRequest;
        vm.viewClientResponse = viewClientResponse;
        vm.viewUpstreamRequest = viewUpstreamRequest;
        vm.viewRawResponse = viewRawResponse;
        vm.outcomeClass = outcomeClass;

        loadData();

        function buildParams() {
            return {
                page: vm.pagingParams.page - 1,
                size: 20,
                sort: getSort(),
                from: moment(vm.fromDate).startOf('day').toISOString(),
                to: moment(vm.toDate).endOf('day').toISOString(),
                outcome: vm.outcome || undefined,
                coverage: vm.coverage || undefined,
                profile: vm.profile || undefined,
                province: vm.province || undefined,
                fsa: vm.fsa || undefined,
                addressQuery: vm.addressQuery || undefined
            };
        }

        function loadData() {
            return AvmPrequalifications.query(buildParams(), function(result, headers) {
                vm.probes = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            }, function(error) {
                AlertService.error(error.data && error.data.message);
            }).$promise;
        }

        function getSort() {
            return vm.pagingParams.predicate + ',' + (vm.pagingParams.ascending ? 'asc' : 'desc');
        }

        function transition() {
            $state.go($state.$current, {
                page: vm.pagingParams.page === 1 ? null : vm.pagingParams.page,
                sort: getSort() === defaultSort ? null : getSort()
            }, { notify: false }).then(loadData);
        }

        /**
         * Apply a filter change: jump back to the first page, then reload.
         */
        function applyFilters() {
            vm.pagingParams.page = 1;
            transition();
        }

        /**
         * Download a CSV of the current (filtered) result set. An over-cap export comes back as a 400 with
         * the message in a header, which the global error interceptor surfaces as an alert.
         */
        function exportCsv() {
            var params = buildParams();
            delete params.page;
            delete params.size;
            delete params.sort;
            return AvmPrequalifications.export(params).$promise.then(function(response) {
                if (response && response.file) {
                    FileSaver.saveAs(response.file, 'avm-prequalifications.csv');
                }
            });
        }

        /**
         * Open a modal showing the request node this probe was sent with — internal, for vendor escalation.
         */
        function viewRequest(probe) {
            openDetail(probe, 'request');
        }

        /**
         * Open a modal showing the request the client posted to pre-flight, exactly as it arrived — the
         * only body that shows fields we dropped on the way in.
         */
        function viewClientRequest(probe) {
            openDetail(probe, 'client-request');
        }

        /** Open a modal showing the answer the client received. */
        function viewClientResponse(probe) {
            openDetail(probe, 'client-response');
        }

        /**
         * Open a modal showing the payload we actually sent Gnowise — the translated body, not the node
         * above it, which is the distinction a vendor escalation turns on.
         */
        function viewUpstreamRequest(probe) {
            openDetail(probe, 'upstream-request');
        }

        /**
         * Open a modal showing the raw Gnowise response for this probe — internal, for vendor escalation.
         */
        function viewRawResponse(probe) {
            openDetail(probe, 'raw-response');
        }

        function openDetail(probe, mode) {
            $uibModal.open({
                templateUrl: 'app/admin/avm-prequalifications/avm-prequalification-detail-dialog.html',
                controller: 'AvmPrequalificationDetailController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    entity: ['AvmPrequalifications', function(AvmPrequalifications) {
                        if (mode === 'request') {
                            return AvmPrequalifications.getRequestJson({ id: probe.id }).$promise;
                        }
                        if (mode === 'client-request') {
                            return AvmPrequalifications.getClientRequestBody({ id: probe.id }).$promise;
                        }
                        if (mode === 'client-response') {
                            return AvmPrequalifications.getClientResponseBody({ id: probe.id }).$promise;
                        }
                        if (mode === 'upstream-request') {
                            return AvmPrequalifications.getUpstreamRequest({ id: probe.id }).$promise;
                        }
                        return AvmPrequalifications.getRawResponse({ id: probe.id }).$promise;
                    }],
                    probe: function() {
                        return probe;
                    },
                    mode: function() {
                        return mode;
                    }
                }
            });
        }

        /**
         * Colour the outcome cell: a pass is green, a confidence rejection red, and the two operational
         * outcomes orange — those are our problem to fix, not the property's.
         */
        function outcomeClass(outcome) {
            if (outcome === 'PASSED') {
                return 'label label-success';
            }
            if (outcome === 'REJECTED_LOW_CONFIDENCE') {
                return 'label label-danger';
            }
            return 'label label-warning';
        }
    }
})();
